import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { apiRequest } from "@/api/client";
import { toast } from "sonner";

function Block({ docs, k, title, ok, setOk }) {
  return (
    <section className="space-y-2 rounded-lg border bg-white p-4" data-testid={`legal-${k}`}>
      <h2 className="font-heading text-lg font-bold">{title}</h2>
      <pre className="max-h-64 overflow-auto whitespace-pre-wrap text-sm leading-relaxed">{docs[k].text}</pre>
      <label className="flex items-start gap-3 text-base font-medium">
        <input type="checkbox" className="mt-1 h-6 w-6" checked={ok[k]} onChange={(e) => setOk({ ...ok, [k]: e.target.checked })} />
        <span>Ho letto e accetto (versione {docs[k].version})</span>
      </label>
    </section>
  );
}

// Primo accesso: informativa e atto di nomina art. 28 GDPR. L'accettazione registra data, ora e versione/impronta.
export default function AuditorLegal({ onDone }) {
  const [docs, setDocs] = useState(null);
  const [ok, setOk] = useState({ informativa: false, nomina: false });
  const [busy, setBusy] = useState(false);

  useEffect(() => { apiRequest("/auditor/legal").then(setDocs).catch((e) => toast.error(e.message)); }, []);
  if (!docs) return <p className="p-4">Caricamento documenti…</p>;

  const accept = async () => {
    setBusy(true);
    try {
      await apiRequest("/auditor/gdpr/accept", { method: "POST", body: JSON.stringify({ informativa_sha256: docs.informativa.sha256, nomina_sha256: docs.nomina.sha256, accept: true }) });
      onDone(await apiRequest("/auditor/me"));
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-4" data-testid="auditor-legal">
      <h1 className="font-heading text-2xl font-bold">Prima di iniziare</h1>
      <p className="text-slate-700">Per lavorare come auditor devi accettare l'informativa e l'atto di nomina a responsabile del trattamento (art. 28 GDPR). Registriamo data, ora e versione dei documenti.</p>
      <Block docs={docs} k="informativa" title="Informativa privacy" ok={ok} setOk={setOk} />
      <Block docs={docs} k="nomina" title="Nomina a responsabile del trattamento" ok={ok} setOk={setOk} />
      <Button className="h-14 w-full text-lg" disabled={busy || !ok.informativa || !ok.nomina} onClick={accept} data-testid="legal-accept">Accetto e continuo</Button>
    </div>
  );
}
